import styled from 'styled-components'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'

export const CardSliderOuter = styled.div<{
  $topPadding: string
  $bottomPadding: string
  $bgTheme: string
}>`
  ${({ theme, $topPadding, $bottomPadding, $bgTheme }) => {
    let themeStyles
    if ($bgTheme === 'Light') {
      themeStyles = `
      background-color: ${theme.webMktNewPalette.white};
      `
    }

    if ($bgTheme === 'Grey') {
      themeStyles = `
      background-color: ${theme.webMktNewPalette.deepBlue[10]};
      `
    }

    return `
      ${themeStyles}
      max-width: 1920px;
      min-height: 620px;
      padding: ${setPaddingSize($topPadding)}px 40px  ${setPaddingSize($bottomPadding)}px 224px;
  
      ${theme.breakpoints.down('lg')}{
        padding: 48px 32px;
      }
    `
  }}
`

export const CardSliderWrapper = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    flex-direction: column-reverse;
  }

  .CardSlider__Content {
    max-width: 43%;
    padding-right: 24px;
    ${({ theme }) => theme.breakpoints.down('md')} {
      max-width: 40%;
    }
    ${({ theme }) => theme.breakpoints.down('sm')} {
      max-width: 50%;
    }
    ${({ theme }) => theme.breakpoints.down('xs')} {
      max-width: 100%;
      padding-right: 0px;
      margin-top: 100px;
    }
    .CardSlider__Eyebrow {
      margin-bottom: 24px;
      color: ${({ theme }) => theme.webMktNewPalette.black};
    }

    .CardSlider__Title {
      margin-bottom: 24px;

      ${({ theme }) => theme.breakpoints.down('md')} {
      }
      ${({ theme }) => theme.breakpoints.down('xs')} {
      }
    }

    .CardSlider__Desc {
      margin-bottom: 24px;

      p {
        color: ${({ theme }) => theme.webMktNewPalette.black};

        ${({ theme }) => theme.breakpoints.down('xs')} {
        }
      }
    }

    .CardSlider__Link {
      color: ${({ theme }) => theme.webMktNewPalette.black};
      &:hover {
        color: ${({ theme }) => theme.webMktNewPalette.black};
      }
    }

    .slick-list {
      .slick-slide {
        &.slick-current {
          z-index: 1;
        }
      }
    }
  }

  .CardSlider__Image {
    width: 57%;
    position: relative;

    ${({ theme }) => theme.breakpoints.down('md')} {
      max-width: 60%;
      width: 60%;
    }
    ${({ theme }) => theme.breakpoints.down('sm')} {
      max-width: 50%;
    }
    ${({ theme }) => theme.breakpoints.down('xs')} {
      max-width: 100%;
      width: 100%;
    }
    .CardSlider__Image-Card {
      position: relative;
      .CardSlider__Image-Gradient {
        position: absolute;
        background: rgba(238, 238, 238, 0.8);
        width: calc(100% - 24px);
        height: 100%;
        z-index: 1;
        transition: all 0.2s;
        max-width: 442px;
        margin: 0 auto;
        left: 0;
        right: auto;
        ${({ theme }) => theme.breakpoints.down('xs')} {
          right: 0;
        }
      }
      .bg-image {
        max-width: 442px;
        height: 520px;
        object-fit: cover;
        object-position: center;
        width: calc(100% - 24px);
        margin: 0 24px 0 0;
        ${({ theme }) => theme.breakpoints.down('xs')} {
          margin: 0 auto;
          width: calc(100% - 24px);
          max-height: 440px;
        }
      }
      .logo {
        position: absolute;
        bottom: 0;
        width: calc(300px - 24px);
        height: auto;
        right: auto;
        margin: 0 auto;
        top: 50%;
        left: calc(50% - 12px);
        transform: translate(-50%, -50%);
        z-index: 2;
        ${({ theme }) => theme.breakpoints.down('xs')} {
          left: 50%;
        }
      }
    }

    .CardSlider__Count {
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      text-transform: uppercase;
      max-width: 48%;
      width: 100%;
      position: absolute;
      margin-top: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        max-width: 86%;
      }
      ${({ theme }) => theme.breakpoints.down('xs')} {
        margin: 40px auto;
        left: 0;
        right: 0;
      }
      .count-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 74%;
        position: relative;
        @media screen and (max-width: 1440px) {
          width: 90%;
        }
        ${({ theme }) => theme.breakpoints.down('md')} {
          width: 90%;
        }
        ${({ theme }) => theme.breakpoints.down('sm')} {
          width: 76%;
        }
        ${({ theme }) => theme.breakpoints.down('xs')} {
          margin: 0 auto;
          width: 200px;
        }

        &:before {
          content: '';
          position: absolute;
          background-color: ${({ theme }) => theme.webMktNewPalette.background.dark.default};
          opacity: 0.3;
          width: calc(100% - 90px);
          height: 1px;
          margin: 0 45px;
        }
      }
    }
    .slick-list {
      ${({ theme }) => theme.breakpoints.down('lg')} {
        padding: 0 18% 0 0 !important;
      }
      ${({ theme }) => theme.breakpoints.down('md')} {
        padding: 0 !important;
      }

      .slick-slide {
        transition: all 0.2s;

        .CardSlider__Image-Card {
          .CardSlider__Image-Link {
            pointer-events: none;
          }
          .logo {
            display: block;
          }
        }

        &.slick-current {
          opacity: 1;
          .CardSlider__Image-Card {
            .CardSlider__Image-Gradient {
              background: ${({ theme }) => theme.webMktNewPalette.alphaBlack[40]};
              .CardSlider__Image-Link {
                pointer-events: auto;
                width: 100%;
                height: 100%;
                position: relative;
                display: block;
              }
            }

            .logo {
              display: block;
            }
          }
        }
      }
    }
    .slick-arrow {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.background.dark.default};
      border-right: 1px solid ${({ theme }) => theme.webMktNewPalette.background.dark.default};
      z-index: 1;

      &.slick-next {
        transform: rotate(45deg);
        right: calc(50% + 32px);
        bottom: -77px;
        top: auto;
        &:before {
          display: none;
        }
        ${({ theme }) => theme.breakpoints.down('lg')} {
          right: calc(50% + 0px);
        }
        @media screen and (max-width: 1440px) {
          right: calc(50% - 48px);
        }
        @media screen and (max-width: 1366px) {
          right: calc(50% - 70px);
        }
        ${({ theme }) => theme.breakpoints.down('md')} {
          right: calc(50% - 70px);
        }
        ${({ theme }) => theme.breakpoints.down('sm')} {
          right: calc(50% - 196px);
        }
        ${({ theme }) => theme.breakpoints.down('xs')} {
          right: -15px;
          top: 50%;
          bottom: 0;
        }
      }

      &.slick-prev {
        transform: rotate(-135deg);
        left: calc(50% - 96px);
        bottom: -77px;
        top: auto;
        &:before {
          display: none;
        }
        ${({ theme }) => theme.breakpoints.down('lg')} {
          left: calc(50% - 76px);
        }
        @media screen and (max-width: 1440px) {
          left: calc(50% - 0px);
        }
        @media screen and (max-width: 1366px) {
          left: calc(50% - 0px);
        }
        ${({ theme }) => theme.breakpoints.down('md')} {
          left: calc(50% - 0px);
        }
        ${({ theme }) => theme.breakpoints.down('sm')} {
          left: calc(50% + 116px);
        }
        ${({ theme }) => theme.breakpoints.down('xs')} {
          left: -15px;
          top: 50%;
          bottom: auto;
        }
      }
    }
    .slick-dots {
      opacity: 0;
      pointer-events: none;
    }
  }
`
